import React from "react";
import AvatarImg from "./controls/Avatar";
import Button from "./controls/Button";
import Input from "./controls/Input";
// import Textarea from './Textarea'
import Select from "./controls/Select";
import SelectWithSearch from "./controls/SelectWithSearch";
import MultipleSelect from "./controls/MultipleSelect";
import RadioButtons from "./controls/RadioButtons";
// import CheckboxGroup from './CheckboxGroup'
import DatePicker from "./controls/DatePicker";
// import ChakraInput from './ChakraInput'
import Tree from "./controls/Tree";
import Table from "./controls/table/";
import Owner from "./controls/OwnerForm";
import SwitchField from "./controls/Switch";
import AutoCompleteField from "./controls/AutoComplete";
import ImageUpload from "./controls/ImageUpload";
import CheckboxField from "./controls/Checkbox";

function parseOptions(options) {
  if (!options) return undefined;
  if (Array.isArray(options)) return options;
  try { return JSON.parse(options); } catch { return undefined; }
}

function AppControl(props) {
  const { control, options, ...rest } = props;
  const parsedOptions = parseOptions(options);
  switch (control) {
    case "avatar":
      return <AvatarImg {...rest} />;
    case "button":
      return <Button {...rest} />;
    case "text":
      return <Input type="text" {...rest} />;
    case "password":
      return <Input type="password" {...rest} />;
    // case 'textarea':
    //   return <Textarea {...rest} />
    case "select":
      return <Select {...rest} options={parsedOptions} />;
    case "selectwithsearch":
      return <SelectWithSearch {...rest} options={parsedOptions} />;
    case "multiselect":
      return <MultipleSelect {...rest} options={parsedOptions} />;
    case "radio":
      return <RadioButtons {...rest} options={parsedOptions} />;
    case "checkbox":
      return <CheckboxField {...rest} options={parsedOptions} />;
    case "date":
      return <DatePicker {...rest} />;
    // case 'chakraInput':
    //   return <ChakraInput {...rest} />
    case "tree":
      return <Tree {...rest} options={options} />;
    case "table":
      return <Table {...rest} />;
    case "owner":
      return <Owner {...rest} />;
    case "switch":
      return <SwitchField {...rest} />;
    case "autocomplete":
      return <AutoCompleteField {...rest} options={parsedOptions} />;
    case "image":
      return <ImageUpload {...rest} />;
    default:
      return null;
  }
}

export default AppControl;
